import { createTypography } from './create-typography';
import { createComponents } from './create-components';

// Here we do not modify the "palette" and "shadows" because "light" and "dark" mode
// may have different values.

export const createOptions = (config) => {
  const { direction = 'ltr' } = config;

  return {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440,
      },
    },
    components: createComponents(),
    direction,
    shape: {
      borderRadius: 8,
    },
    typography: createTypography(),
  };
};

/**
 * xs (extra-small): Screens smaller than 600px — typically for mobile devices.
 * sm (small): Screens between 600px and 900px — typically for small tablets or large phones.
 * md (medium): Screens between 900px and 1200px — typically for tablets or small laptops.
 * lg (large): Screens between 1200px and 1536px — typically for desktops.
 * xl (extra-large): Screens larger than 1536px — for large desktops and widescreens.
 *
 * Example for fontSize
 * fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem', lg: '1.75rem',  xl: '2rem' }
 */
